// ============================================================================
// page-service / how.js
// ----------------------------------------------------------------------------
// "How we work" section — two linked Flickity instances:
//
//   .services-how__buttons   horizontal Step pills strip (center-aligned).
//   .services-how__slider    main step content carousel (left-aligned).
//   .services-how__slider-nav.prev / .next   external arrows for the slider.
//
// Two-way binding:
//   - Click a pill → activates it, slides to the matching content card.
//   - Slider `change` → activates the matching pill.
//   - Initial state: slide 0 + pill 0 active.
// ============================================================================

import { initCarousels } from "../carousel";

document.addEventListener("DOMContentLoaded", function () {
  const buttonsStrip = document.querySelector(".services-how__buttons");
  const sliderStrip = document.querySelector(".services-how__slider");
  if (!buttonsStrip || !sliderStrip) return;

  buttonsStrip.style.display = "block";
  sliderStrip.style.display = "block";

  const buttonsInstances = initCarousels(".services-how__buttons", {
    cellAlign: "center",
    contain: true,
    pageDots: false,
    wrapAround: false,
  });
  const sliderInstances = initCarousels(".services-how__slider", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: false,
  });
  if (!sliderInstances || !sliderInstances.length) return;

  const slider = sliderInstances[0].flickity;

  // External arrows drive the slider.
  const prev = document.querySelector(".services-how__slider-nav.prev");
  const next = document.querySelector(".services-how__slider-nav.next");
  if (prev)
    prev.addEventListener("click", function () {
      slider.previous();
    });
  if (next)
    next.addEventListener("click", function () {
      slider.next();
    });

  // Pills jump the slider; slider changes activate the matching pill.
  const buttonEls = document.querySelectorAll(".services-how__buttons-item");

  function setActive(index) {
    buttonEls.forEach(function (el) {
      el.classList.remove("active");
    });
    if (buttonEls[index]) buttonEls[index].classList.add("active");
  }

  buttonEls.forEach(function (el, index) {
    el.addEventListener("click", function () {
      setActive(index);
      slider.select(index);
    });
  });

  slider.on("change", function (index) {
    setActive(index);
  });

  // Initial state.
  slider.select(0, false, true);
  setActive(0);
});
